import React, { forwardRef } from 'react'
import { Dialog, DialogContent, Grow } from '@mui/material'
import { motion } from 'framer-motion'
import { ScheduleMeeting } from 'components/ScheduleMeeting'

const Transition = forwardRef(function Transition(props, ref) {
  return <Grow timeout={300} ref={ref} {...props} />
})

export default function ScheduleAppointment({ isAdmin, onClose }) {
  return (
    <Dialog
      open
      onClose={onClose}
      TransitionComponent={Transition}
      fullWidth
      maxWidth={'sm'}
      PaperProps={{
        sx: {
          overflow: { xs: 'auto', sm: 'visible' },
          margin: '16px',
          width: 'calc(100% - 32px)',
          '@media (max-height:960px)': {
            overflow: 'auto',
          },
        },
      }}
    >
      <DialogContent sx={{ overflow: 'visible' }}>
        <motion.div
          key="scheduler"
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.95 }}
          transition={{ duration: 0.3, ease: 'easeInOut' }}
        >
          <ScheduleMeeting closeModal={onClose} />
        </motion.div>
      </DialogContent>
    </Dialog>
  )
}
